import { render, staticRenderFns } from "./CardStatisticDrawer.vue?vue&type=template&id=21fdf923"
import script from "./CardStatisticDrawer.vue?vue&type=script&lang=js"
export * from "./CardStatisticDrawer.vue?vue&type=script&lang=js"
import style0 from "./CardStatisticDrawer.vue?vue&type=style&index=0&id=21fdf923&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports